import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
// import * as Actions from '../actions';

class ShopSettings extends Component {

  constructor(props) {
    super(props);
    this.state = {


    };
  }

  componentDidMount() {

    window.scrollTo(0, this.props.menuPosition);
  }

  render() {

    return (
      <div className="articles">
        <h1>Nastavení eshopu:</h1>
        <div className="col100">
        <ul>
          <li><Link to="/infoupdate">Provozovatel</Link></li>
          <li><Link to="/shippingpaying">Platba a doprava</Link></li>
          <li><Link to="/articles">Informace (články)</Link></li>
        </ul>

        </div>
      </div>); } }

      function mapStateToProps(state){
        return {admin: state.admin, menuPosition: state.menuPosition};
      }
      export default connect(mapStateToProps)(ShopSettings);



// WEBPACK FOOTER //
// ./src/pages/ShopSettings.js